// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"40":"debug","154":"customers","766":"statistics","983":"products"}[chunkId] + "." + {"40":"99ad4cd7","154":"580886a8","766":"1325cecd","983":"e98366e3"}[chunkId] + ".css";
};